export enum Module {
  FileManager = 'FileManager',
  Warranty = 'Warranty',
  Scheduler = 'Scheduler',
  Administration = 'Administration',
  All = 'All',
  HomeBuilding = 'Home Building',
  Sales = 'Sales',
  DSM = 'DSM',
  BuyerConnect = 'BuyerConnect',
  Accounting = 'Accounting',
  ExecutiveConsole = 'ExecutiveConsole'
}

export enum ModuleId {
  FileManager = '873BA19B-6554-44FD-80E2-506BAA5CE3E2',
  Warranty = '3DEC90DA-350B-47AB-AA1F-CBE65F98E433',
  Scheduler = 'F2C564E1-D938-4051-B6B7-14436A898381',
  Administration = '2279E65D-47A6-4E95-9BE6-8A58C5B0892E',
  HomeBuilding = '135DFD6B-1CCC-4103-8BCC-80BA805ABC8C',
  Sales = 'b217eed2-012b-41d3-a9df-42338a592a97',
  DSM = 'b8f48c9a-0018-43c9-bf3f-ca6568a5607a',
  BuyerConnect = 'f9c8e2a1-3b4d-5e6f-7a8b-9c0d1e2f3a4b',
  Accounting = 'fec30a8a-fd32-4936-a0ac-05f011a9e9a9',
  ExecutiveConsole = 'e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b'
}

export const ModuleIds: Partial<Record<Module, ModuleId>> = {
  [Module.FileManager]: ModuleId.FileManager,
  [Module.Warranty]: ModuleId.Warranty,
  [Module.Scheduler]: ModuleId.Scheduler,
  [Module.Administration]: ModuleId.Administration,
  [Module.HomeBuilding]: ModuleId.HomeBuilding,
  [Module.Sales]: ModuleId.Sales,
  [Module.DSM]: ModuleId.DSM,
  [Module.BuyerConnect]: ModuleId.BuyerConnect,
  [Module.Accounting]: ModuleId.Accounting,
  [Module.ExecutiveConsole]: ModuleId.ExecutiveConsole
};

export const AllModules: readonly Module[] = [
  Module.FileManager,
  Module.Warranty,
  Module.Scheduler,
  Module.Administration,
  Module.HomeBuilding,
  Module.Accounting,
  Module.Sales,
  Module.DSM,
  Module.BuyerConnect,
  Module.ExecutiveConsole
];
